export type Session =
  | { authenticated: false }
  | {
      authenticated: true;
      person_id: string;
      display_name: string;
      email: string | null;
      roles: string[];
      expires_at: number;
      csrf_token: string;
    };

export async function loadSession(): Promise<Session> {
  const response = await fetch("/api/v1/session", {
    credentials: "include",
    headers: { Accept: "application/json" }
  });
  if (!response.ok) throw new Error("Could not load the account session");
  return response.json() as Promise<Session>;
}

export function login(next = window.location.href): void {
  window.location.assign(`/api/v1/auth/login?next=${encodeURIComponent(next)}`);
}

export async function logout(session: Session): Promise<void> {
  if (!session.authenticated) return;
  const response = await fetch("/api/v1/auth/logout", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": session.csrf_token
    }
  });
  if (!response.ok) throw new Error("Could not sign out");
  const payload = (await response.json()) as { logout_url: string };
  window.location.assign(payload.logout_url);
}

